import { TrackCode, EducationalInvestment, EducationalInvestmentCode } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const educationalInvestmentApi = createApi({
  reducerPath: 'educationalInvestmentApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['EducationalInvestment'],
  endpoints: (build) => ({
    getEducationalInvestments: build.query<EducationalInvestment[], undefined>({
      query: () => 'educational-investment',
      keepUnusedDataFor: 60 * 60 * 24,
      providesTags: [{ type: 'EducationalInvestment', id: 'LIST' }],
    }),
    getEducationalInvestmentById: build.query<EducationalInvestment, { id: number }>({
      query: ({ id }) => `educational-investment/${id}`,
      keepUnusedDataFor: 60 * 60 * 24,
      providesTags: (_result, _error, { id }) => [{ type: 'EducationalInvestment', id }],
    }),
    getEducationalInvestmentByCode: build.query<
      EducationalInvestment,
      { code: EducationalInvestmentCode }
    >({
      query: ({ code }) => `educational-investment/code/${code}`,
      keepUnusedDataFor: 60 * 60 * 24,
      providesTags: (_result, _error, { code }) => [{ type: 'EducationalInvestment', id: code }],
    }),
    getEducationalInvestmentsByCareerTrack: build.query<
      { target: EducationalInvestment[]; others: EducationalInvestment[] },
      { careerTrackCode: TrackCode | undefined }
    >({
      query: ({ careerTrackCode }) => `educational-investment/career-track/${careerTrackCode}`,
      keepUnusedDataFor: 60 * 60 * 24,
      providesTags: (_result, _error, { careerTrackCode }) => [
        { type: 'EducationalInvestment', id: `career-track-${careerTrackCode}` },
      ],
    }),
  }),
});

export const {
  useGetEducationalInvestmentsQuery,
  useGetEducationalInvestmentByIdQuery,
  useGetEducationalInvestmentByCodeQuery,
  useGetEducationalInvestmentsByCareerTrackQuery,
  useLazyGetEducationalInvestmentByIdQuery,
  useLazyGetEducationalInvestmentByCodeQuery,
  useLazyGetEducationalInvestmentsByCareerTrackQuery,
  usePrefetch: usePrefetchEducationalInvestment,
  util: { resetApiState },
} = educationalInvestmentApi;
